import { render, staticRenderFns } from "./exchange-pay-result.vue?vue&type=template&id=6e3ec99a&scoped=true&"
import script from "./exchange-pay-result.vue?vue&type=script&lang=js&"
export * from "./exchange-pay-result.vue?vue&type=script&lang=js&"
import style0 from "./exchange-pay-result.vue?vue&type=style&index=0&id=6e3ec99a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ec99a",
  null
  
)

export default component.exports